import { BoxBase, CardBase, StackBase } from '@fmc-digital/ui';
import { default as SkeletonBase } from '@mui/material/Skeleton';
import React from 'react';

export const NewLoanInProgressSkeleton = () => {
    return (
        <CardBase>
            <StackBase spacing={2} direction="row">
                <SkeletonBase width={64} height={64} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                <StackBase spacing="1rem" width="100%">
                    <StackBase spacing="1rem" direction="row">
                        <SkeletonBase width={'60%'} height={32} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                        <SkeletonBase width={'40%'} height={32} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                    </StackBase>
                    <SkeletonBase width={'75%'} height={16} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                    <SkeletonBase width={'75%'} height={16} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                    <SkeletonBase width={'75%'} height={64} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                    <SkeletonBase width={'100%'} height={32} variant="rounded" sx={{ bgcolor: '#E6EDF0' }} />
                </StackBase>
            </StackBase>
        </CardBase>
    );
};
